import styled from 'styled-components'
import { Flex } from 'grid-styled'
import { space } from 'styled-system'

export const Block = styled(Flex)`
  background-color: ${props => props.color};
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
`

export const Header = styled(Flex)`
  width: 100%;
  justify-content: center;
  font-size: 40px;
  font-family: Satisfy;
  color: ${props => props.color};
  padding: 15px;
`

export const Body = styled(Flex)`
  flex-direction: column;
  font-size: 18px;
  font-family: Montserrat;
  color: ${props => props.color};
  padding: 0 5% 0 5%;
  white-space: pre-wrap;
  align-items: center;
`

export const Photo = styled.img`
  ${space};
`

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  justify-content: space-between;
  align-content: space-between;
  width: 100%;
  padding: 0 0 0 5%;
`

export const ListItem = styled.li`
  padding: 5px;
  :before {
    content: '· ';
  }
`

export const StyledLink = styled.a`
  font-weight: bold;
  text-decoration: underline;
  color: ${props => props.color};
  &:hover {
    color: ${props => props.hoverColor};
  }
`



// WEBPACK FOOTER //
// ./src/containers/CS/styles.js